import { useRouter } from "next/router"
import { removeBlankAttributes } from "../utils"

export const useUpdateSearchParams = () => {
  const router = useRouter()

  const updateParams = (params: any, pathname: string, scroll?: boolean) => {
    const finalParam: any = removeBlankAttributes(params)

    router.push(
      {
        pathname: pathname,
        query: { ...finalParam },
      },
      undefined,
      { scroll: scroll || false },
    )
  }
  return [updateParams]
}
